import { Injectable, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, ResponseOptions, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Enterprise } from '../.modal/enterprise';
import { User } from '../.modal/user';
import { Project } from '../.modal/project';

import 'rxjs/add/operator/map';
@Injectable()
export class UserService {
	user: any;
	enterprise: Enterprise;
	constructor(private http: Http, private router: Router, public db: AngularFireDatabase) {
		this.user = JSON.parse(localStorage.getItem('user'));
	}

	updateUser(userGoogle) {
		var userData = new User();
		userData.fromGoogle(this.user);
		console.log(userData);
		this.db
			.object(this.user.uid)
			.update(userData)
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
	}
	createUser(user, enterpriseId) {
		var userData = new User();
		userData.login = user.email;
		userData.enterprises = [enterpriseId];
		this.db
			.object(this.user.uid)
			.update(userData)
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
		/*
		this.db
			.list('/' + user.uid)
			.push(userData)
			.then(item => {
				
				console.log(item);
			});*/
	}
	createEnterprise(users, type) {
		//create enterprise data
		this.enterprise = new Enterprise(users, type);
		this.db
			.object(this.enterprise.id)
			.update(this.enterprise)
			.then(data => {
				console.log(data);
				console.log('Enterprise id-' + this.enterprise.id);
				this.createUser(this.user, this.enterprise.id);
			})
			.catch(error => {
				console.log(error);
			});
		/*
		this.db
			.list('/')
			.push(this.enterprise)
			.then(item => {
				console.log('Enterprise id-' + item.key);
				this.createUser(this.user, item.key);
			});*/
	}
	registerUser() {
		this.user = JSON.parse(localStorage.getItem('user'));
		var updateUserOnLogin = false;
		this.db.list(this.user.uid).subscribe(data => {
			console.log(data);
			if (data == null || data.length == 0) {
				var userData = new User();
				userData.login = this.user.email;
				this.createEnterprise([this.user.uid], 'private');
			} else if (!updateUserOnLogin) {
				updateUserOnLogin = true;
				this.updateUser(data);
			}
			/*
			this.allData = data;
			if (this.allData.enterpriseId == null) {
				console.log(this.enterprise);
				this.db
					.list('/')
					.push(this.enterprise)
					.then(item => {
						
						console.log(item.key);
						this.allData.enterpriseId = item.key;
						console.log(this.allData);
						this.db.list('/').push(this.allData);
						//this.userData.update('enterpriseId', item.key);
						
					});
			}*/
		});
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.providers/user.service.ts